export class APIErrorMessages {
  static AccessDenied = 'GraphQL error: Access denied';
  static NoSuchDocument = 'GraphQL error: No such document';
}
